import type { ProcessStep } from '../types/shop';

export const processSteps: ProcessStep[] = [
  {
    title: 'Free estimate',
    description: 'Stop by, book a time, or send photos online. No appointment needed for an estimate.',
  },
  {
    title: 'Insurance & approval',
    description: 'We file with your insurer, meet the adjuster, and get every repair approved before we start.',
  },
  {
    title: 'Repair',
    description: 'Parts arrive, structure is restored, and damaged panels are repaired or replaced.',
  },
  {
    title: 'Paint & refinish',
    description: 'Color is matched by spectrophotometer, sprayed, and baked for a factory-grade cure.',
  },
  {
    title: 'Inspection & pickup',
    description: 'A final quality check, a wash, and your keys back, with a walkthrough of the work.',
  },
];

export const insurers = [
  'State Farm',
  'GEICO',
  'Progressive',
  'Allstate',
  'USAA',
  'Farmers',
  'Liberty Mutual',
  'Mountain West',
];
